import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import * as Sentry from "@sentry/react";
import App from './App';
import './index.css';

// @ts-ignore
const env = import.meta.env || {};

Sentry.init({
  dsn: env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The marketing routes ("/" and "/privacy-policy") are prerendered to static
// HTML at build time (scripts/prerender.mjs). Hydrate that markup when we land
// on one of them; otherwise (e.g. /hq/*, which is served the same index.html
// shell by the SPA fallback) mount a fresh root.
const PRERENDERED_ROUTES = new Set(['/', '/privacy-policy']);
const path = window.location.pathname.replace(/\/+$/, '') || '/';
const isPrerendered = PRERENDERED_ROUTES.has(path) || path === '/blog' || path.startsWith('/blog/');

if (isPrerendered && rootElement.firstElementChild) {
  hydrateRoot(rootElement, app);
} else {
  rootElement.replaceChildren();
  createRoot(rootElement).render(app);
}